import ServiceModule from "@/store/modules/service.module";
import { Machine } from "xstate";
const ServiceMachine = Machine({
    id: "ServiceMachine",
    initial: "idle",
    states: {
        idle: {
            always: { target: "gettingServiceList" },
        },
        gettingServiceList: {
            invoke: {
                id: "gettingServiceListView",
                src: () => ServiceModule.GetServices(),
                onDone: { target: "loadedServiceList" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedServiceList: {},
        serviceUnavailable: {
            type: "final",
        }
    },
});
export default ServiceMachine;
